/*
 *   Copyright (c) 2021 Propally.Inc
 *   All rights reserved.
 */

import { PropallyApiFactory } from "../module/custom_api_factory";

export const GetPrefectures = async () => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1MasterDataPrefecturesGet({
      withCredentials: true,
    });
    return { success: true, prefectures: res.data, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return {
        success: false,
        prefectures: null,
        error: "画面をリロードし、再度ログインしてください",
      };
    }
    return {
      success: false,
      prefectures: null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};

export const GetCities = async (prefecture) => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1MasterDataPrefecturesPrefectureNameCitiesGet(prefecture, { withCredentials: true });
    return { success: true, cities: res.data, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return {
        success: false,
        cities: null,
        error: "画面をリロードし、再度ログインしてください",
      };
    }
    return {
      success: false,
      cities: null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};

export const GetTowns = async (prefecture, city) => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefecture, city, {
      withCredentials: true,
    });
    return { success: true, towns: res.data, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return {
        success: false,
        towns: null,
        error: "画面をリロードし、再度ログインしてください",
      };
    }
    return {
      success: false,
      towns: null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};

export const GetRailways = async () => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1MasterDataRailwaysGet({ withCredentials: true });
    return { success: true, railways: res.data, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return {
        success: false,
        railways: null,
        error: "画面をリロードし、再度ログインしてください",
      };
    }
    return {
      success: false,
      railways: null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};

export const GetStations = async (railway) => {
  const fp = PropallyApiFactory();
  try {
    const res = await fp.v1MasterDataRailwaysRailwayNameStationsGet(railway, {
      withCredentials: true,
    });
    return { success: true, stations: res.data, error: "" };
  } catch (e) {
    if (e.response?.status === 401) {
      return {
        success: false,
        stations: null,
        error: "画面をリロードし、再度ログインしてください",
      };
    }
    return {
      success: false,
      railways: null,
      error: "ネットワークエラーです。しばらくたってからお試しください",
    };
  }
};
